module.exports = __webpack_public_path__ + "media/images/apple-8fbc38439e713846f162bd6670975755.svg";